// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-107897c5] {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #9e9e9e;\n  border-radius: 5px;\n}\n.container[data-v-107897c5]:hover {\n  border: 1px solid #000;\n}\n.chart[data-v-107897c5] {\n  cursor: pointer;\n  max-height: 550px;\n  padding: 15px 10px 10px 10px;\n}\n", ""]);
// Exports
module.exports = exports;
